import React, { useState, useEffect } from 'react';
import {
  Widget,
  MasterDetailForm,
  Row,
  InlineEditColumnProps,
  Table,
  FormText,
  Button,
  FormInput,
} from '@digital/ui';
import { Collapse, Icon } from 'antd';
import { ResumoCapex } from '@app/api/ordemInvestimento';
import { mountFormFilterDropDown } from '@app/components/FormFilterDropDown';
import { compareNumber, compareText } from '@app/helpers/comparators';

interface FormResumoCapexProps {
  resumoCapex: ResumoCapex[];
  projetoId: string;
  //resumoHeader: string;
}

const { Panel } = Collapse;

const FormTableOrcadoCapexProjeto = (props: FormResumoCapexProps) => {
  const { resumoCapex, projetoId } = props;

  const [resumoHeader, setResumoHeader] = useState<string>();
  const [valorTotal, setValorTotal] = useState<string>();

  useEffect(() => {
    const getData = () => {
      if (resumoCapex.length > 0) {
        var capex = resumoCapex[0];
        if (capex) {
          var header = capex.numero + ' - ' + capex.revisao + ' - ' + capex.dataAprovacao;
          setResumoHeader(header);
          setValorTotal(capex.valorTotalCurrency);
        }
      }
    };

    getData();
  }, [resumoCapex]);

  const customColumns = () => {
    return [
      {
        title: 'N',
        dataIndex: 'index',
        width: '1%',
      },
      {
        title: 'Centro de Custo',
        dataIndex: 'numeroCentroDeCusto',
        width: '3%',
        ...mountFormFilterDropDown("numeroCentroDeCusto", "Pesquisar por centro de custo"),
        sorter: (a: any, b: any) => compareNumber(a.numeroCentroDeCusto, b.numeroCentroDeCusto),
      },
      {
        title: 'Conta Contábil',
        dataIndex: 'crfContaContabilCodigo',
        width: '3%',
        ...mountFormFilterDropDown("crfContaContabilCodigo", "Pesquisar por conta contábil"),
        sorter: (a: any, b: any) => compareNumber(a.crfContaContabilCodigo, b.crfContaContabilCodigo),
      },
      {
        title: 'Nome',
        dataIndex: 'nome',
        width: '35%',
        ...mountFormFilterDropDown("nome", "Pesquisar por nome"),
        sorter: (a: any, b: any) => compareText(a.nome, b.nome),
      },
      {
        title: 'Valor orçado',
        dataIndex: 'valorTotalCurrency',
        key: 'valorTotalCurrency',
        children: [
          {
            title: `${valorTotal || ''}`,
            dataIndex: 'valorCurrency',
            width: '1%',
          },
        ],
      },
    ] as InlineEditColumnProps<ResumoCapex>[];
  };

  return (
    <>
      <Collapse bordered={false} defaultActiveKey={['2']} expandIcon={() => <Icon type="arrows-right_4" />}>
        <Panel key="2" header="Resumo orçado Plurianual" style={{ border: 0 }}>
          <MasterDetailForm>
            <Widget
              actions={[
                projetoId && (
                  <Button
                    title="CONSULTAR DISTRIBUIÇÃO ORÇADO"
                    type="primary"
                    icon="commons-search"
                    onClick={() => {
                      window.location.href = `/Cr/moduloOrcado/capex/detail/${projetoId}`;
                    }}
                  />
                ),
              ]}>
              <Row>
                {resumoHeader && (
                  <FormInput label="Planilha ORÇADO atual" name="numero" value={resumoHeader || ''} span={3} disabled />
                )}
              </Row>
              <br />
              <Row>
                <Table rowKey="index" columns={customColumns()} dataSource={resumoCapex || []} />
              </Row>
            </Widget>
          </MasterDetailForm>
        </Panel>
      </Collapse>
    </>
  );
};

export default FormTableOrcadoCapexProjeto;
